import React from 'react';
import { ArrowUpRightIcon, StarIcon } from 'lucide-react';
import { reviewSummary, testimonials } from '../data/site';
export function Reviews() {
  return <section id="reviews" className="w-full bg-white py-20 lg:py-28" data-id="element-132" data-mp="2heou5rs9gfxu">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-133" data-mp="2maxav9m3wh74">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between" data-id="element-134" data-mp="2raialm93otkw">
          <div data-id="element-135" data-mp="2wa4qy4k86pxx">
            <p className="text-[12px] font-bold uppercase tracking-[0.18em] text-brand-dark" data-id="element-136" data-mp="2waefdnpmgp1i">
              Customer reviews
            </p>
            <h2 className="mt-4 max-w-[620px] font-display text-[34px] font-extrabold leading-[1.08] tracking-[-0.02em] text-ink sm:text-[42px]" data-id="element-137" data-mp="309nbgz84wz08">
              Rated 5.0 by East End customers
            </h2>
            <div className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-2 text-[15px] text-steel/75" data-id="element-138" data-mp="3a3dwtv8ystbp">
              <span className="flex items-center gap-1" aria-hidden="true" data-id="element-139" data-mp="3ey9rz49hzwt1">
                {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-brand text-brand" data-id="element-140" data-mp="2rd6zsa5go8qt" data-mpi={i} />)}
              </span>
              <span className="font-semibold text-ink" data-id="element-141" data-mp="2mcj77k1l3juh">
                {reviewSummary.rating} average
              </span>
              <span className="h-4 w-px bg-black/15" aria-hidden="true" data-id="element-142" data-mp="2herhmwoew9tg" />
              <span data-id="element-143" data-mp="2ddxsjzz8goyz">{reviewSummary.count} reviews</span>
              <span className="h-4 w-px bg-black/15" aria-hidden="true" data-id="element-144" data-mp="3a35g1djex85j" />
              <span data-id="element-145" data-mp="3a2di3w2ceyc3">NPS {reviewSummary.nps}</span>
              <span className="h-4 w-px bg-black/15" aria-hidden="true" data-id="element-146" data-mp="353k84dm9lpgo" />
              <span data-id="element-147" data-mp="30dc60gyx513e">Verified by {reviewSummary.source}</span>
            </div>
          </div>

          <a href={reviewSummary.url} target="_blank" rel="noreferrer" className="inline-flex shrink-0 items-center gap-2 self-start whitespace-nowrap rounded-md bg-ink px-6 py-3.5 text-[15px] font-bold text-white transition-colors duration-150 ease-out hover:bg-steel lg:self-auto" data-id="element-148" data-mp="30azh1juqtqgu">
            Read more reviews on SureCritic
            <ArrowUpRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-149" data-mp="1m7h2u3e0xat7" />
          </a>
        </div>

        <ul className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-150" data-mp="1r6bk30wcerb7">
          {testimonials.map(review => <li key={review.quote} className="flex flex-col overflow-hidden rounded-xl bg-charcoal" data-id="element-151" data-mp="1hee83rxifvbf">
              <img src={review.image} alt={review.imageAlt} loading="lazy" style={{
            objectPosition: review.imagePosition ?? 'center'
          }} className="aspect-[4/3] w-full object-cover" data-id="element-152" data-mp="13e3ies7xsmru" />
              <div className="flex flex-1 flex-col p-6 lg:p-7" data-id="element-153" data-mp="yf0bt3cb68hr">
                <div className="flex items-center gap-2.5" data-id="element-154" data-mp="2nuqak57d7zct">
                  <span className="flex items-center gap-0.5" aria-hidden="true" data-id="element-155" data-mp="2nv9hyrze35cl">
                    {Array.from({
                  length: 5
                }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-brand-light text-brand-light" data-id="element-156" data-mp="h67s4su5no9g" data-mpi={i} />)}
                  </span>
                  <span className="text-[11px] font-bold uppercase tracking-[0.1em] text-chalk/55" data-id="element-157" data-mp="qwskvzn5dykg">
                    SureCritic · Verified
                  </span>
                  <span className="sr-only" data-id="element-158" data-mp="m3r4tob7fsza">5 out of 5 stars</span>
                </div>

                <blockquote className="mt-4 font-display text-[19px] font-bold leading-snug tracking-tight text-white" data-id="element-159" data-mp="zz1wyty2dzzy">
                  “{review.quote}”
                </blockquote>

                <div className="mt-auto pt-6" data-id="element-160" data-mp="19ude1iwy3jav">
                  <p className="text-[15px] font-semibold text-white" data-id="element-161" data-mp="14vk05pdqxqa6">
                    {review.name}
                  </p>
                  <p className="mt-1 text-[13px] leading-relaxed text-chalk/55" data-id="element-162" data-mp="3bnb08vw7vdmu">
                    {[review.location, review.vehicle, review.date].filter(Boolean).join(' · ')}
                  </p>
                </div>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}